import { Injectable } from '@angular/core';
import { MarketsService } from '../core/markets/markets.service';
import { combineLatest, distinctUntilChanged, map, Observable, ReplaySubject, shareReplay } from 'rxjs';
import { Market } from '../core/markets/market';

export enum CRMMarketContext {
  EditContext,
  ViewContext,
}

@Injectable({ providedIn: 'root' })
export class PartnerCRMSalespersonMarketService {
  marketDropdownOptions$ = this.marketsService.markets; //needed for legacy opps
  selectedMarketId$ = this.marketsService.selectedMarketId$;

  constructor(private readonly marketsService: MarketsService) {
    this.currentContext$$.next(CRMMarketContext.ViewContext);
  }

  private currentContext$$ = new ReplaySubject<CRMMarketContext>();
  selectMarketContext(marketContext: CRMMarketContext): void {
    this.currentContext$$.next(marketContext);
  }
  selectMarketByID(marketContext: CRMMarketContext, marketId: string): void {
    this.selectMarketContext(marketContext);
    this.marketsService.selectMarketByID(marketId);
  }
  selectMarket(marketContext: CRMMarketContext, market: Market): void {
    this.selectMarketContext(marketContext);
    this.marketsService.selectMarket(market);
  }
  getMarkets(): Observable<Market[]> {
    return this.marketsService.getMarkets();
  }
  getMarket(marketId: string): Observable<Market> {
    return this.marketsService.getMarket(marketId);
  }
  setSelectedMarketId(marketId: string): void {
    this.marketsService.selectMarketByID(marketId);
  }

  currentMarketId$ = combineLatest([
    this.marketsService.selectedMarketId$,
    this.marketsService.adminCanAccessAllPartnerMarkets$,
    this.marketsService.userAccessibleMarkets$,
    this.currentContext$$,
  ]).pipe(
    map(([selectedMarketId, hasAccessToAllMarkets, userAccessibleMarkets, userContext]) => {
      if (userContext === CRMMarketContext.EditContext && selectedMarketId) {
        return selectedMarketId;
      }
      if (hasAccessToAllMarkets) {
        return '';
      }
      return userAccessibleMarkets[0].market_id;
    }),
    distinctUntilChanged(),
    shareReplay(1),
  );
  userAccessibleMarkets$ = this.marketsService.userAccessibleMarkets$;
}
